import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=9737bc6c&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"
import style0 from "./step2.vue?vue&type=style&index=0&id=9737bc6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9737bc6c",
  null
  
)

export default component.exports